module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/2@2x_74e7a0dfc98981eda3d4b899c0a6e2c8.png";